module.exports = __webpack_public_path__ + "static/img/doctor_img.5790b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctor_img.png
// module id = mLOA
// module chunks = 7